const timesheetKeys = {
  tsByUserMap: ["tsByUserMap"],
  approvedTsByUser: (userRef) => ["approvedTimesheets", userRef],
  timesheetList: (params) => ["timesheetList", params],
};

export default timesheetKeys;
